import parseQueryParams from '../parse-query-string.js';
import pipe from '../pipe.js';
import { encode, decode } from '../base64.js';
import parseJSON from '../parse-json.js';
import { fbTrack } from './fb-track.js';
export const hasFbParam = (search) => {
    return search
        .replace('?', '')
        .split('&')
        .some((param) => param.match(/(^fb=)/));
};
export const removeFbParamFromQuery = (search) => () => {
    const params = search
        .replace('?', '')
        .split('&')
        .filter((param) => !param.match(/(^fb=)/))
        .join('&');
    return params ? '?' + params : '';
};
export const encodeFbTrack = (type, eventName, customData = {}) => {
    const arr = [type, eventName, customData];
    return encode(JSON.stringify(arr));
};
export const fbTrackFromQueryParam = (search) => {
    // This takes a base64 encoded URL parameter that contains an object
    // representing a Facebook track
    const trackFromQueryParam = pipe(parseQueryParams, (params) => params === null || params === void 0 ? void 0 : params.fb, decode, (str) => parseJSON(str, []), (arr) => fbTrack(...arr), removeFbParamFromQuery(window.location.search), (newQuery) => window.history.replaceState(null, '', window.location.pathname + newQuery));
    trackFromQueryParam(search);
};
//# sourceMappingURL=fb-query-track.js.map